import axios from 'axios';
import { GoalLibraryGoal, GoalLibraryGroup } from '../models/serviceModels/GoalLibraryGoal';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export const getGoalLibraryGroups = async (): Promise<GoalLibraryGroup[]> =>
    (await axios.get(`${baseUrl}/organizations/goal-library/groups`)).data;

export const getGoalLibraryGoals = async (groupId?: string, search?: string): Promise<GoalLibraryGoal[]> =>
    (await axios.get(`${baseUrl}/organizations/goal-library/goals`, { params: { groupId, search } })).data;

export const searchGoalLibraryGoals = async (query: string): Promise<GoalLibraryGoal[]> =>
    (await axios.get(`${baseUrl}/organizations/goal-library/options`, { params: { q: query, take: 25 } })).data;

export const createGoalLibraryGroup = async (name: string, tags: string[] = []): Promise<GoalLibraryGroup> =>
    (await axios.post(`${baseUrl}/organizations/goal-library/groups`, { name, tags })).data;

export const createGoalLibraryGoal = async (text: string, groupId?: string | null, tags: string[] = []): Promise<GoalLibraryGoal> =>
    (await axios.post(`${baseUrl}/organizations/goal-library/goals`, { text, groupId, tags })).data;

export const removeGoalLibraryGoal = async (goalId: string): Promise<void> => {
    await axios.delete(`${baseUrl}/organizations/goal-library/goals/${goalId}`);
};

export const updateGoalLibraryGoal = async (goalId: string, text: string, tags: string[]): Promise<GoalLibraryGoal> =>
    (await axios.put(`${baseUrl}/organizations/goal-library/goals/${goalId}`, { text, tags })).data;

export const moveGoalLibraryGoal = async (goalId: string, groupId?: string | null): Promise<void> => {
    await axios.post(`${baseUrl}/organizations/goal-library/goals/${goalId}/move`, { groupId });
};

export const updateGoalLibraryGroup = async (groupId: string, name: string, tags: string[]): Promise<GoalLibraryGroup> =>
    (await axios.put(`${baseUrl}/organizations/goal-library/groups/${groupId}`, { name, tags })).data;

export const removeGoalLibraryGroup = async (groupId: string, removeGoals: boolean): Promise<void> => {
    await axios.delete(`${baseUrl}/organizations/goal-library/groups/${groupId}`, { params: { removeGoals } });
};

export interface GoalLibraryCasePlan {
    clientId: string;
    clientName: string;
    casePlanId: string;
    casePlanName: string;
    usedAt: string;
}

export const getGoalLibraryGoalCasePlans = async (goalId: string, skip = 0): Promise<GoalLibraryCasePlan[]> =>
    (await axios.get(`${baseUrl}/organizations/goal-library/goals/${goalId}/case-plans`, { params: { skip, take: 50 } })).data;
